import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'lupa-confirm-back-dialog',
    templateUrl: './confirm-back-dialog.component.html',
    styleUrls: ['./confirm-back-dialog.component.scss'],
})
export class ConfirmBackDialogComponent implements OnInit {
    constructor(public dialogRef: MatDialogRef<ConfirmBackDialogComponent>) {}

    onNoClick(e): void {
        if (e) {
            e.preventDefault();
        }
        this.dialogRef.close();
    }
    confirm(e) {
        if (e) {
            e.preventDefault();
        }
        this.dialogRef.close(true);
    }
    ngOnInit() {}
}
